import services from './../../../services/service'; // Service Class
import SecondHeader from './../../Second-Header/index.vue'; // Second Header
import Sidebar from './../../Sidebar/index.vue'; // Sidebar
import MainFooter from './../../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../../SearchBar.vue'; // Search Bar
//
import Preset from './../../../mixins/preset.js'; //preset
//
import CNinsuranceForm from '../../../templates/CNInsuranceForm/index.vue'
import CNinsuranceFileClaim from '../../../templates/CNinsuranceFileClaim/index.vue'
import CNinsuranceFileCompliant from '../../../templates/CNinsuranceFileComplaint/index.vue'
let service = new services();

export default {
    name: 'CNInsurance',
    mixins: [Preset],
    data () {
        return {
            user: {},
            cninsurance_listing:{},
            cninsurance:{},
            cninsurance_form_entry:{},
            set_flie_claim:false,
            set_flie_complaint:false,
            set_component_view:{},
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'search-bar': SearchBar,
        'cninsurance-post-form': CNinsuranceForm,
        'cninsurance-file-claim': CNinsuranceFileClaim,
        'cninsurance-file-complaint': CNinsuranceFileCompliant
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },

            set(newVal){
                //this function will run whenever the input changes
                if(this.user.user_id != null){
                    this.rate = newVal;
                    this.rateBusiness();
                }else{
                    localStorage.setItem("cn_prv_page","businesses");//log current page
                    this.preset();
                }
            }
        }
    },
    methods: {
        //settings
        presetXX() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                    }else {
                           // this.$router.push('/login');
                      }
                }).catch((err) => {
                    if(err) {
                //     this.$router.push('/login');
                    }
                })
            }else {
               // this.$router.push('/login');
            }
            
        },

        //settings
        setViewComponent(view,attr1,attr2){
            this.set_component_view = {};
            this.set_component_view[view] = true;
        },

        //--//settings
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
        
        //business
        setComponent(business) {
            this.business = business;
            this.panelFlag = true;
            //set has reviewed and has rated
            let reviews = this.business.business_reviews;
            reviews.forEach(function(element) {
                if(this.user.user_id == element.review_user_id){
                    this.has_reviewed = true;
                    console.log(element.review_user_id)
                }
            }, this);
            let rating = this.business.business_ratings;
            rating.forEach(function(element) {
                if(this.user.user_id == element.rate_user_id){
                    this.has_rated = true;
                }
            }, this);
                  
        },


        getCNInsurance() { 
            // if(this.$route.params.listing){
            if(this.$route.params.cninsurancelisting){
                let str_rs = this.$route.params.cninsurancelisting;
                var res = str_rs.split("-");
                var listing = res[1];
                let navi = this.$router;
                service.getCNinsurance(this,listing).then(data => {
                    if(data.body.status == 200) {
                        this.cninsurance_listing = data.body.data;
                        //for form resolve issues
                        this.cninsurance_form_resolve_issues_redirect_url = listing;
                    }
                }).catch((err) => {
                    if(err) {
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }
        },

    },
    created: function(){
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }else{
            localStorage.setItem("cn_prv_page","businesses");//log current page
        }
        this.getCNInsurance();
     }
}


// WEBPACK FOOTER //
// ./src/components/CNInsuranceSystem/CNInsuranceListing/script.js